import React from "react";

const SummaryRow = ({ label, value, valueColor = "#1B4B31" }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #f1f5f9",
        paddingBottom: "10px",
      }}
    >
      <span
        style={{
          color: "#6b7280",
          fontWeight: "500",
        }}
      >
        {label}
      </span>

      <span
        style={{
          fontWeight: "700",
          color: valueColor,
        }}
      >
        {value}
      </span>
    </div>
  );
};

export default SummaryRow;